import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Divider } from 'semantic-ui-react';
import { fetchStageFormData } from '../issue/issues-slice';
import ItemModel from '../issue/ItemModel';
import SignatureSideBar from '../issue/SignatureSideBar';
import StageData from '../issue/StageData';
import { IssueDetails } from '../issue/IssueDetails';
import ESignDisclosureModal from '../issue/ESignDisclosureModal';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

export function ViewIssuePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showApproveSignatureModal, setShowApproveSignatureModal] = useState(false);
  const [showRejectSignatureModal, setShowRejectSignatureModal] = useState(false);
  const itemAssignmentCode = useSelector((state) => state.auth.user.itemAssignmentCode);
  const tosStatus = useSelector((state) => state.issues.issue.tosStatus);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const itemApiResponse = useSelector((state) => {
    return state.issues.issue.stage.formData;
  });

  useEffect(() => {
    dispatch(fetchStageFormData({ itemAssignmentCode, navigate }));
  }, [itemAssignmentCode]);

  const item = () => {
    return new ItemModel({ itemData: itemApiResponse.data });
  };

  function handleApproval() {
    setShowApproveSignatureModal((prevState) => !prevState);
    setShowRejectSignatureModal(false);
  }

  function handleReject() {
    setShowRejectSignatureModal((prevState) => !prevState);
    setShowApproveSignatureModal(false);
  }

  const handleCloseSignatureModal = () => {
    setShowApproveSignatureModal(false);
    setShowRejectSignatureModal(false);
  };

  const issueType = item()?.type();
  return (
    <div className="view-issue-page">
      <ESignDisclosureModal tosNotAccepted={tosStatus === 'NotAccepted'} issueType={issueType}></ESignDisclosureModal>
      <div>
        <div>
          <div className="issue-header">{item()?.issueDetails()?.fullName}</div>
          <Divider></Divider>
        </div>
        <div>
          {item()?.issueDetails() && <IssueDetails issueDetails={item()?.issueDetails()}></IssueDetails>}
          <span className="stages">
            {item()
              ?.stagesData()
              ?.map((stageData) => {
                return (
                  <StageData
                    key={stageData.name}
                    stageData={{
                      name: stageData.name,
                      due_date: stageData.due_date,
                      stageAssignees: stageData?.stageAssignees(),
                      tasks: stageData?.tasks(),
                      attachments: stageData?.attachments(),
                      customFields: stageData?.customFields(),
                      signatures: stageData?.signatures(),
                      isCurrentStage: stageData?.isCurrentStage,
                    }}
                  ></StageData>
                );
              })}
          </span>{' '}
        </div>
        {item()?.isCurrentStepInApprovalPending() && (
          <div className="button-wrapper">
            <div>{item()?.isCurrentStepInApprovalPending()}</div>
            <Button className="ui green button approve-button" onClick={handleApproval}>
              <FormattedMessage id="signatureType.approve" defaultMessage="Approve" />
            </Button>
            <Button className="ui red button reject-button" onClick={handleReject}>
              <FormattedMessage id="signatureType.reject" defaultMessage="Reject" />
            </Button>
          </div>
        )}

        <SignatureSideBar
          signatureReason={item()?.currentStepData()?.signatureReason}
          signatureType={'approve'}
          approve={true}
          stageName={issueType}
          requiresComment={item()?.requiresComment()}
          onClose={handleCloseSignatureModal}
          visible={showApproveSignatureModal}
          showSuccessModal={showSuccessModal}
          setShowSuccessModal={setShowSuccessModal}
        ></SignatureSideBar>
        <SignatureSideBar
          signatureReason={item()?.currentStepData()?.signatureReason}
          signatureType={'reject'}
          approve={false}
          stageName={issueType}
          requiresComment={item()?.requiresComment()}
          onClose={handleCloseSignatureModal}
          visible={showRejectSignatureModal}
          showSuccessModal={showSuccessModal}
          setShowSuccessModal={setShowSuccessModal}
        ></SignatureSideBar>
        <Divider hidden></Divider>
      </div>
    </div>
  );
}
